module.exports = __webpack_public_path__ + "img/ANTENNA 2 LIME.a8817f5.svg";